import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { MonitorSuggestApi } from '../../apis/monitor-suggest-api';
import type { MonitorSuggestRepository } from '../../services/monitor-suggest-repository';
import { E_NEWSLETTER_DETAIL_SOURCE } from '../../enums';

@injectable()
export class MonitorSuggestRepositoryImpl implements MonitorSuggestRepository {
    constructor(
        @inject(MonitorSuggestApi) private _monitorSuggestApi: MonitorSuggestApi
    ) { }

    getMonitorRecommendList() {
        return this._monitorSuggestApi.getMonitorRecommendList().then(res => {
            return {
                detail: res.detail.map(item => ({
                    newsLetterId: item.news_letter_id,
                    title: item.title,
                })),
                source: res.recommend_type === 'SUBSCRIBE' ? E_NEWSLETTER_DETAIL_SOURCE.MY : E_NEWSLETTER_DETAIL_SOURCE.LIST,
            }
        })
    }
}
